import { createSelector } from 'reselect'

const selector = state => state.myDriversReducer

export const myDriverFilterSelector = createSelector(
  [selector],
  ({ filters }) => filters
)

export const myDriverLoadMoreSelector = createSelector(
  [selector],
  ({ loadMore }) => loadMore
)

export const myDriverLoadPageSelector = createSelector(
  [selector],
  ({ loadPage }) => loadPage
)

export const myDriverErrorSelector = createSelector(
  [selector],
  ({ error }) => error
)

export const myDriverOffersSelector = createSelector(
  [selector],
  ({ drivers }) => drivers
)

export const myDriverNoMoreSelector = createSelector(
  [selector],
  ({ noMore }) => noMore
)

export const myDriverSetSelector = createSelector(
  [selector],
  ({ setLoad, setError }) => ({ setLoad, setError })
)

export const myDriverDeleteSelector = createSelector(
  [selector],
  ({ deleteLoad, deleteError }) => ({ deleteLoad, deleteError })
)

export const myDriverSelector = createSelector(
  [selector],
  drivers => drivers
)
